import { IconsProps } from '@/types/shared'
import React from 'react'

const UpIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16.59 8.29499L12 12.875L7.41 8.29499L6 9.70499L12 15.705L18 9.70499L16.59 8.29499Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default UpIcons
